import plural from "plural-ru";

export const pluralFile = (qty: number) => plural(qty, "%d файл", "%d файла", "%d файлов");
